/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        /* Carousels */
        $('#main-carousel').carousel({
          interval: 4000,
          keyboard: true
        });

        /* Lightbox chambres */
        lightbox.option({
          alwaysShowNavOnTouchDevices: true,
          albumLabel: "Image %1 sur %2",
          wrapAround: false
        });
        $(window).on('load', function(){
          //$('#lightbox').find('.lb-closeContainer').prependTo('#lightbox .lb-outerContainer');
          //if( $('div > title').length > 0 ){
          //  $('div > title').each(function(){
          //    $(this).parent().hide();
          //  });
          //}
          //if( $(window).width() <= 991 ){
          //  if( $('.bloc-fw').length > 0 ){
          //    $('.bloc-fw > img').css('minHeight', $('.bloc-fw .block-bg').outerHeight()+40 );
          //  }
          //  if( $('.block-chambre').length > 0 ){
          //    $('.block-chambre').each( function(){
          //      $(this).find('.img-bg').css('minHeight', $(this).find('.block-bg').outerHeight()+20 );
          //    });
          //  }
          //}
        });


        /* Mise en place effet au scroll */
        $.fn.visible = function(partial) {
          var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

          return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        $(".bloc-columns .module").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.removeClass("module");
          }
        });

        $(".module-start").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.addClass("come-in");
          }
        });

        $(window).scroll(function(event) {

          $(".module").each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
              el.addClass("come-in");
            }
          });

        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'page_template_template_galerie': {
      init: function() {
        $('#carousel-galerie').carousel({
          interval: false,
          keyboard: true
        });

        $('#carousel-galerie').on('slide.bs.carousel', function ( slide ) {

        });

        $('#carousel-galerie').on('slid.bs.carousel', function () {
          var activeElement = $('.carousel-indicators .active');
          $('.carousel-indicators').scrollLeft( activeElement.position().left );
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_contact': {
      init: function() {
        //Add marker
        function add_marker( $marker, map ) {
          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
          var markerIconVersion;
          //Retina marker icon
          if( window.devicePixelRatio > 1.5 ){
            markerIconVersion = $marker.attr('data-icon2');
          }else{
            markerIconVersion = $marker.attr('data-icon');
          }
          var markerIcon = new google.maps.MarkerImage(markerIconVersion, null, null, null, new google.maps.Size(42,57));
          // create marker
          var marker = new google.maps.Marker({
            position    : latlng,
            map         : map
          });
          // Règle spécifique pour éviter un bug sur certaines version de l'API
          if (window.devicePixelRatio > 1.5) {
            marker.setOptions({ optimized: false });
          }
          // add to array
          map.markers.push( marker );
          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() ){
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content     : $marker.html()
            });
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
              infowindow.open( map, marker );
            });
          }
        }

        //Auto center map and show all markers
        function center_map( map ) {
          // vars
          var bounds = new google.maps.LatLngBounds();
          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
          });
          // only 1 marker?
          if( map.markers.length === 1 ){
            // set center of map
            map.setCenter( bounds.getCenter() );
            if( $(window).width() <= 480 ){
              map.setZoom( 13 );
            }else{
              map.setZoom( 17 );
            }
          }
          else{
            // fit to bounds
            map.fitBounds( bounds );
          }
        }

        //Create new map
        function new_map( $el ) {
          // var
          var $markers = $el.find('.marker');
          // vars
          var styles = [
            {
              "featureType": "landscape.man_made",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f7f1df"
                }
              ]
            },
            {
              "featureType": "landscape.natural",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#d0e3b4"
                }
              ]
            },
            {
              "featureType": "landscape.natural.terrain",
              "elementType": "geometry",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.business",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.medical",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#fbd3da"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#bde6ab"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#ffe15f"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#efd151"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "black"
                }
              ]
            },
            {
              "featureType": "transit.station.airport",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#cfb2db"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#a2daf2"
                }
              ]
            }
          ];
          var args;
          if( $(window).width() >= 960 ){
            args = {
              zoom        : 12,
              center      : new google.maps.LatLng(0, 0),
              mapTypeId   : 'Styled',
              scrollwheel: false,
              draggable: true,
              disableDefaultUI: false,
              scaleControl: true,
              streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
              },
              zoomControl: true,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
              }
            };
          }else{
            args = {
              zoom        : 10,
              center      : new google.maps.LatLng(0, 0),
              mapTypeId   : 'Styled',
              scrollwheel: false,
              draggable: false,
              disableDefaultUI: false,
              scaleControl: true,
              zoomControl: true,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
              }
            };
          }
          // create map
          var map = new google.maps.Map( $el[0], args);
          var styledMapType = new google.maps.StyledMapType(styles, { name: 'Styled' });
          map.mapTypes.set('Styled', styledMapType);
          // add a markers reference
          map.markers = [];
          // add markers
          $markers.each(function(){
            add_marker( $(this), map );
          });
          // center map
          center_map( map );
          // return
          return map;
        }

        //Init map
        var map = null;
        $('.map').each(function(){
          // create map
          map = new_map( $(this) );
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
